import { render } from "./NewsViewCtrl.vue?vue&type=template&id=5ffc2484"
import script from "./NewsViewCtrl.vue?vue&type=script&lang=js"
export * from "./NewsViewCtrl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__